import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";

const GymCitiesListings = ({ setModValues }) => {
  const { gymCitiesLoading, gymCitiesError, gymCities } = useSelector(
    (state) => state.webApi
  );

  const [allGymCitties, setAllGymCitties] = useState([]);

  useEffect(() => {
    if (
      !gymCitiesLoading &&
      !gymCitiesError &&
      gymCities?.status &&
      gymCities?.data?.length > 0
    ) {
      setAllGymCitties(gymCities.data);
    } else {
      setAllGymCitties([]);
    }
  }, [gymCitiesLoading, gymCitiesError, gymCities]);

  const tbColumns = [
    {
      dataField: "city_id",
      text: "city name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.city || "NA"}</span>;
      },
    },
    {
      dataField: "locations",
      text: "mapped locations",
      formatter: (cell, row) => {
        return (
          <span
            className={`tb-data ${row?.locations?.length > 0 ? "link" : ""}`}
            onClick={() =>
              row?.locations?.length > 0 &&
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "mapped_locations",
                rowData: row,
              }))
            }
          >
            {row?.locations?.length || 0}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27"
            style={{
              background: row?.status === "active" ? "#379C00" : "#D90000",
              color: "#fff",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Meta Details",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "manage_metadata",
                rowData: row,
              }))
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M3.62891 17.3603V20.3254C3.62891 20.5985 3.84349 20.8131 4.1166 20.8131H7.08175C7.20855 20.8131 7.33535 20.7643 7.42313 20.6668L18.0743 10.0254L14.4166 6.36775L3.77521 17.0091C3.67768 17.1067 3.62891 17.2237 3.62891 17.3603ZM20.9029 7.19682C20.9933 7.10658 21.065 6.9994 21.114 6.88141C21.1629 6.76341 21.1881 6.63692 21.1881 6.50918C21.1881 6.38143 21.1629 6.25495 21.114 6.13695C21.065 6.01896 20.9933 5.91177 20.9029 5.82154L18.6205 3.53915C18.5302 3.44873 18.4231 3.37699 18.3051 3.32805C18.1871 3.2791 18.0606 3.25391 17.9328 3.25391C17.8051 3.25391 17.6786 3.2791 17.5606 3.32805C17.4426 3.37699 17.3354 3.44873 17.2452 3.53915L15.4603 5.32409L19.1179 8.98176L20.9029 7.19682Z"
                fill="url(#paint0_linear_14023_4477)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_14023_4477"
                  x1="3.62891"
                  y1="11.6344"
                  x2="21.1881"
                  y2="11.6344"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.0447915" stopColor="#B4000B" />
                  <stop offset="1" stopColor="#DD0000" />
                </linearGradient>
              </defs>
            </svg>
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt15">
      {gymCitiesLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <PaymentLinkTable tableData={allGymCitties} tableColumns={tbColumns} />
      )}
    </div>
  );
};

export default GymCitiesListings;
